import React from "react";
import "./Spinner.css";

export default function LoadingScreen({ label }) {
    return (
        <div className="spinner-container">
            <div className="dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
            <p className="loading-message">{label}</p>
        </div>
    );
}